import React, { useEffect, useState } from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize, localizeWithVars } from 'helpers/translator/localize'

const MyLibraryLessonLaunchFailed = props => {

	const [seconds, setSeconds] = useState(5)

	useEffect(() => {
		let timeout
		if (seconds > 0) {
			timeout = setTimeout(() => {
				setSeconds(seconds => seconds - 1)
			}, 1000)
		}
		return () => clearTimeout(timeout)
	}, [seconds])

	const message = seconds > 0
		?
		localizeWithVars('myLibrary_lessonLaunchNotReady_messageWithTime', {seconds})
		:
		localize('myLibrary_lessonLaunchNotReady_message')

	return (<Confirm
		alertTitle={localize('myLibrary_lessonLaunchNotReady_title')}
		btTwo={localize('global_tooltip_gotIt')}
		alertMessage={message}
		actionTwo={props.actions.close}
		closeAction={props.actions.close}
	/>)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		close: myLibraryActions.closeLessonLaunchFailedMessage,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryLessonLaunchFailed)

export { MyLibraryLessonLaunchFailed }
